










































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import FieldInput from '@/components/form/FieldInput.vue';
import { ICreative } from '@/types/campaign/creatives';
import { getCreativeFormOptions } from '@/configs/creativeConfigs';
import { TCreativeFormOptions } from '@/types';
import { getTranslate } from '@/helpers/translateHelpers';
import CreativeService from '@/services/CreativeService';
import { checkEditCreativesHaveErrors } from '@/helpers/creativeHelpers';

export default Vue.extend({
  name: 'UpdateCreativeFields',
  components: { FieldInput },

  props: {
    currentId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      editCreatives: 'campaignCreatives/getEditCreatives',
    }),
    creativeIds(): Array<string> {
      return this.editCreatives.allIds;
    },
    currentCreative(): ICreative {
      return this.editCreatives.byId[this.currentId];
    },
    getCreativeFormOptions(): TCreativeFormOptions {
      return getCreativeFormOptions();
    },
  },
  methods: {
    getTranslate(path: string): string {
      return getTranslate(path);
    },
    resetError(fieldName) {
      this.currentCreative.errors[fieldName] = [];
    },
    validate(): boolean {
      CreativeService.validateCreatives(this.editCreatives.byId);

      return checkEditCreativesHaveErrors();
    },
    apply() {
      CreativeService.updateCreatives(this.editCreatives.byId);
    },
  },
});
